export default {
    name: 'TabInvestmentFunds',
    props: {
        items: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        // Formateamos los datos recibidos desde el componente padre
        itemsFormated() {
            return this.items.map(x => {
                return {
                    status: x.has_mismatch ? 'failed' : 'success',
                    name: x.name_product,
                    key_product: x.key_product,
                    titles_yuri: x.yuri_shares,
                    titles_rd: x.rd_shares,
                    missmatches: x.difference,
                    show_details: true
                };
            });
        },
        // Columnas que queremos mostrar en la tabla
        fields() {
            return ['name', 'titles_yuri', 'titles_rd', 'missmatches', 'show_details'];
        }
    }
};
